var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.8012,
    height: 37.8012,
    rx: 18.9006,
    fill: "#E86A0D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_5215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6953 27.4473V28.012C12.6953 28.5309 13.1175 28.9531 13.6365 28.9531H24.5312C25.0501 28.9531 25.4723 28.5309 25.4723 28.012V27.4473H12.6953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6152 17.6365V17.0695C26.6152 16.5661 26.3627 16.1027 25.9397 15.8298L25.4482 15.5127V14.6157H25.6364C25.9483 14.6157 26.2011 14.3629 26.2011 14.051C26.2011 13.7392 25.9483 13.4863 25.6364 13.4863H12.4958C12.184 13.4863 11.9311 13.7392 11.9311 14.051C11.9311 14.3629 12.184 14.6157 12.4958 14.6157H12.6841V15.5182L12.2116 15.8331C11.8003 16.1074 11.5547 16.5663 11.5547 17.0606V19.379C11.5547 19.6369 11.7294 19.862 11.9793 19.926L15.4229 20.8078L11.9793 21.6896C11.7294 21.7536 11.5547 21.9788 11.5547 22.2367V24.9628C11.5547 25.6375 12.0503 26.1985 12.6965 26.3014H25.4735C26.1197 26.1985 26.6152 25.6375 26.6152 24.9628V23.9943C26.6152 23.7243 26.424 23.492 26.159 23.4401L24.0872 23.0347L26.159 22.6292C26.424 22.5774 26.6152 22.3451 26.6152 22.0751V20.1507C26.6152 19.9095 26.462 19.695 26.2339 19.6167L24.1281 18.8936L26.2339 18.1705C26.462 18.0923 26.6152 17.8777 26.6152 17.6365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9919 12.3568L21.1254 11.14C21.1662 10.7683 21.0464 10.3954 20.7969 10.1169C20.5473 9.83844 20.1897 9.67871 19.8157 9.67871H18.3449C17.971 9.67871 17.6133 9.83844 17.3638 10.1169C17.1142 10.3954 16.9944 10.7683 17.0352 11.14L17.1687 12.3568L20.9919 12.3568Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_5215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2748,
    height: 19.2748,
    fill: "white",
    transform: "translate(9.44531 9.67871)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderReturn);
export default __webpack_public_path__ + "static/media/orderReturn.872c0ecdb2848ae9134352f53d3c8384.svg";
export { ForwardRef as ReactComponent };